import $http from '@/api/index'
/**
 * @description 新增路径
 * @constructor
 */
function AddTaskTreePath(treePath) {
  let getUrl = {
    method: 'POST',
    url: 'task/AddTaskTreePath',
    requestType: 2,
  }
  console.log('pasteList', JSON.stringify({
    '': treePath
  }));
  return $http(getUrl, {
    '': treePath
  })
}
/**
 * 修改路径
 * @param {*} TreePath 
 * @param {*} Person 
 */
function UpdateTaskTreePath(TreePath, Person) {
  let getUrl = {
    method: 'POST',
    url: 'task/UpdateTaskTreePath',
    requestType: 2,
  }
  console.log('pasteList', JSON.stringify({
    TreePath: TreePath,
    Person: Person
  }));
  return $http(getUrl, {
    TreePath: TreePath,
    Person: Person
  })
}
/**
 * @description 获取任务路径
 * @constructor
 */
function GetTaskTreePathList(para) {
  let getUrl = {
    method: 'POST',
    url: 'task/GetTaskTreePathList',
    requestType: 2,
  }
  return $http(getUrl, para)
}
/**
 * 删除路径
 * @param {*} TreePath []
 * @param {*} Person {}
 */
function DelTaskTreePath(TreePath, Person) {
  let getUrl = {
    method: 'POST',
    url: 'task/DelTaskTreePath',
    requestType: 2,
  }
  return $http(getUrl, {
    TreePath: TreePath,
    Person: Person
  })
}

/**
 * 获取常用文件夹
 * @param {*} person {}
 */
function GetFrequentTreePath(person) {
  let getUrl = {
    method: 'POST',
    url: 'task/GetFrequentTreePath',
    requestType: 2,
  }
  return $http(getUrl, person)
}
/**
 * 设置常用文件夹
 * @param {*} frequentTreePath []
 */
function AddFrequentTreePath(frequentTreePath) {
  let getUrl = {
    method: 'POST',
    url: 'task/AddFrequentTreePath',
    requestType: 2,
  }
  return $http(getUrl, {
    '': frequentTreePath
  })
}
/**
 * 取消常用文件夹
 * @param {*} NodeId []
 * @param {*} Person {}
 */
function DelFrequentTreePath(NodeId, Person) {
  let getUrl = {
    method: 'POST',
    url: 'task/DelFrequentTreePath',
    requestType: 2,
  }
  return $http(getUrl, {
    NodeId: NodeId,
    Person: Person
  })
}

/**
 * 获取当前路径的树形父级
 * @param {*} curPath
 */
function GetCurPathParentTree(curPath) {
  let getUrl = {
    method: 'GET',
    url: 'task/GetCurPathParentTree',
    requestType: 2,
  }
  return $http(getUrl, {
    curPath: curPath
  })
}

/**
 * 获取当前路径的树形父级
 * @param {*} curPath
 */
function GetAllSubTreePathTaskIds(TreePath) {
  let getUrl = {
    method: 'GET',
    url: 'task/GetAllSubTreePathTaskIds?nodeid='+TreePath,
    requestType: 2,
  }
  console.log('pasteList', JSON.stringify({
    '': TreePath
  }));
  return $http(getUrl, {
   
  })
}


/**
 *
 *获取文件夹模式下任务子集的任务完成情况
 * @param {*} nodeId
 * @returns
 */
function GetAllSubTreePathTask(nodeId) {
  let getUrl = {
    method: 'GET',
    url: `task/GetAllSubTreePathTask?nodeId=${nodeId}`,
    requestType: 2,
  }

  return $http(getUrl,{});
}

/**
 * 获取群组的任务集合
 * @param {*} groupId 
 */
function GetTreePathByGroupId(groupId){
  let getUrl = {
    method: 'GET',
    url: 'task/GetTreePathByGroupId',
    requestType: 2,
  }
  return $http(getUrl, {
    groupId: groupId
  })
}

/**
 * 获取所有的跟我有关的任务群组
 * @param {*} person 
 */
function GetMyChatGroup(person){
  let getUrl = {
    method: 'POST',
    url: 'task/GetMyChatGroup ',
    requestType: 2,
  }
  return $http(getUrl, person)
}

/**
 * 获取我权限范围内可查看的所有任务组（构建成了树状结构）
 * @param {*} person 
 */
function GetMyTaskTreePath(person,onlyGroup,PermissionType){
  let getUrl = {
    method: 'POST',
    url: 'task/GetMyTaskTreePath',
    requestType: 2,
  }
  if(onlyGroup==null){
    onlyGroup=true
  }
  if(PermissionType==null){
    PermissionType=2
  }
  return $http(getUrl, {Person:person,OnlyGroup:onlyGroup,PermissionType:PermissionType})
  // return $http(getUrl, person)
}

/**
 * 删除群组任务
 * @param {*} model 
 */
function DelChatGroupTask(model){
  let getUrl = {
    method: 'POST',
    url: 'task/DelChatGroupTask',
    requestType: 2,
  }
  return $http(getUrl, model)
}

/**
 * 新增群组任务
 * @param {*} model 
 */
function  AddChatGroupTask(model){
  let getUrl = {
    method: 'POST',
    url: 'task/AddChatGroupTask',
    requestType: 2,
  }
  return $http(getUrl, model)
}


/**
 * 获取群组任务
 * @param {*} person 
 */
function GetTaskByChatGroupId(groupId,userId){
  let getUrl = {
    method: 'GET',
    url: 'task/GetTaskByChatGroupId',
    requestType: 2,
  }
  return $http(getUrl, {
    groupId: groupId,
    userId:userId
  })
}

/**
 * 所属任务组
 * @param {*} groupId 
 * @param {*} userId 
 */
function GetTaskTreePathGroup(taskId,userId){
  let getUrl = {
    method: 'GET',
    url: 'task/GetTaskTreePathGroup',
    requestType: 2,
  }
  return $http(getUrl, {
    taskId: taskId,
    userId:userId
  })
}

function InsertTaskIntoFolder(subList,folderId,folderType) {
  let getUrl = {
    method: 'POST',
    url: 'task/InsertTaskIntoFolder',
    requestType: 2,
  }
  return $http(getUrl, {
    SubList: subList,
    FolderId:folderId,
    FolderType:folderType
  })
}

export default {
  AddTaskTreePath,
  UpdateTaskTreePath,
  GetTaskTreePathList,
  DelTaskTreePath,
  GetFrequentTreePath,
  AddFrequentTreePath,
  DelFrequentTreePath,
  GetCurPathParentTree,
  GetAllSubTreePathTaskIds,
  GetAllSubTreePathTask,
  GetTreePathByGroupId,
  GetMyChatGroup,
  GetMyTaskTreePath,
  DelChatGroupTask,
  AddChatGroupTask,
  GetTaskByChatGroupId,
  GetTaskTreePathGroup,
  InsertTaskIntoFolder
}
